import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhoIsItFor } from './components/WhoIsItFor';
import { PlansSection } from './components/PlansSection';
import { UrgencySection } from './components/UrgencySection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen flex flex-col font-sans" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <HeroSection data-id="element-4" />
          <ProblemSection data-id="element-5" />
          <SolutionSection data-id="element-6" />
          <TestimonialsSection data-id="element-7" />
          <WhoIsItFor data-id="element-8" />
          <PlansSection data-id="element-9" />
          <UrgencySection data-id="element-10" />
          <FAQSection data-id="element-11" />
          <FinalCTA data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
        <WhatsAppFloat data-id="element-14" />
      </div>
    </LanguageProvider>;
}